import Image from 'components/Basic/Image/Image';
import { getTescomaClubCardImage } from 'helpers/getTescomaClubImage';
import { useDomainConfig } from 'hooks/useDomainConfig';
import useTranslation from 'next-translate/useTranslation';
import twMerge from 'utils/twMerge';

type TClubLogoProps = {
    width?: number;
    height?: number;
    className?: string;
};

export const TClubLogo: FC<TClubLogoProps> = ({ width = 100, height = 63, className = '' }) => {
    const { defaultLocale } = useDomainConfig();
    const { t } = useTranslation();

    return (
        <Image
            src={getTescomaClubCardImage(defaultLocale)}
            alt={t('Tescoma club')}
            width={width}
            height={height}
            className={twMerge(`max-h-[${height}px] max-w-[${width}px]`, className)}
        />
    );
};
